import { render, staticRenderFns } from "./DataUsers.vue?vue&type=template&id=5fa4b53c&scoped=true"
import script from "./DataUsers.vue?vue&type=script&lang=js"
export * from "./DataUsers.vue?vue&type=script&lang=js"
import style0 from "./DataUsers.vue?vue&type=style&index=0&id=5fa4b53c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa4b53c",
  null
  
)

export default component.exports